import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import Button from '../Button/Button.js';

/**
 * Bottone della confirm.
 * Lo stato di primary è definito da una combinazione delle proprietà text, flat e primary di Button.
 * Se il bottone è primary, tenta di ottenere il focus dopo il mount.
 */
function ConfirmButton({ text, onClick, disabled, loading, primary, }) {
    const ref = useRef(null);
    useEffect(() => {
        if (primary) {
            setTimeout(() => {
                var _a;
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
        }
    }, [primary]);
    return (jsx(Button, { flat: primary, text: !primary, onClick: onClick, className: primary ? 'confirm__button--primary' : undefined, primary: true, disabled: disabled, loading: loading, ref: ref, children: text }));
}
ConfirmButton.defaultProps = {
    disabled: false,
    loading: false,
    primary: false,
};

export { ConfirmButton as default };
